module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_5_2.6a2cc08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_5_2.png
// module id = DVRv
// module chunks = 0